module.exports = __webpack_public_path__ + "static/media/298421.35819fdf.png";